import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteWorkstation } from '../../../../actions';

class WorkstationDeleteButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
    };
  }

  onClickDelete = () => {
    const { dispatchDeleteWorkstation, workstationId } = this.props;

    dispatchDeleteWorkstation({ workstationId });
  };

  onClickShowModal = () => this.setState({ showModal: true });

  onClickCancel = () => this.setState({ showModal: false });

  render() {
    const { showModal } = this.state;

    const warningModal = (
      <ConfirmationModal
        show={showModal}
        onClickConfirm={this.onClickDelete}
        onClickCancel={this.onClickCancel}
      />
    );

    const deleteButton = (
      <Button color="danger" onClick={this.onClickShowModal}>
        Eliminar
      </Button>
    );

    return (
      <Fragment>
        {deleteButton}
        {warningModal}
      </Fragment>
    );
  }
}

WorkstationDeleteButton.propTypes = {
  workstationId: PropTypes.number.isRequired,
  dispatchDeleteWorkstation: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchDeleteWorkstation: deleteWorkstation,
};

export default connect(null, mapDispatchToProps)(WorkstationDeleteButton);
